/**
 * Textos do resumo da lista da aba Meus Estudos (Flux Personalizado, #1997).
 */

/**
 * Contagem da lista em pt-BR (.dc.html:722: só o 1 fica no singular).
 *
 * @param total - Total de estudos da consulta (`data?.total`).
 * @returns '24.087 estudos', '1 estudo', '0 estudos'; ou `null` sem um inteiro seguro >= 0
 *   (sem total, NaN, negativo, fracionário), quando a tela mostra '—'.
 */
export default function formatStudyCount(total: number | undefined): string | null {
  if (total === undefined || !Number.isSafeInteger(total) || total < 0) return null;
  return `${total.toLocaleString('pt-BR')} ${total === 1 ? 'estudo' : 'estudos'}`;
}
